import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Check, Calendar, Share2, Phone } from "lucide-react";

export default function Confirmation() {
  const { bookingId } = useParams();
  const [b, setB] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/bookings/${bookingId}`);
        setB(data);
      } catch (e) {
        // ignore
      }
    })();
  }, [bookingId]);

  if (!b) return <div className="py-10 text-light-ink animate-pulse">Loading...</div>;

  const waText = encodeURIComponent(`I just booked ${b.restaurant?.name} via Tablo for ${b.pax} on ${b.date} at ${b.time}. Booking ID ${b.id}.`);

  return (
    <div className="space-y-6 animate-fade-up max-w-lg mx-auto text-center">
      <div className="w-20 h-20 rounded-full bg-amber/15 border-2 border-amber mx-auto flex items-center justify-center" data-testid="confirm-check">
        <Check className="w-10 h-10 text-amber" strokeWidth={2}/>
      </div>
      <div>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">You're confirmed</p>
        <h1 className="font-serif text-3xl">See you at {b.restaurant?.name}.</h1>
        <p className="text-light-ink text-sm mt-2">A WhatsApp + email confirmation has been queued (mock for demo).</p>
      </div>

      <div className="tablo-card p-5 text-left space-y-3" data-testid="confirm-card">
        <div className="flex justify-between"><span className="text-light-ink">Booking ID</span><span className="font-medium font-mono text-xs">{b.id}</span></div>
        <div className="flex justify-between"><span className="text-light-ink">Restaurant</span><span className="font-medium">{b.restaurant?.name}</span></div>
        <div className="flex justify-between"><span className="text-light-ink">Date / Time</span><span className="font-medium">{b.date} · {b.time}</span></div>
        <div className="flex justify-between"><span className="text-light-ink">Guests</span><span className="font-medium">{b.pax}</span></div>
        <div className="flex justify-between"><span className="text-light-ink">Deposit paid</span><span className="font-medium">₹{(b.deposit_amount_inr || 0).toLocaleString("en-IN")}</span></div>
        <div className="flex justify-between"><span className="text-light-ink">Balance at venue</span><span className="font-medium">₹{(b.balance_amount_inr || 0).toLocaleString("en-IN")}</span></div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <a href={`tel:${b.restaurant?.contact_phone || ""}`} className="tablo-card p-4 hover:shadow-tablo-lg flex flex-col items-center gap-1" data-testid="confirm-call-btn">
          <Phone className="w-4 h-4 text-amber" strokeWidth={1.6}/>
          <span className="text-xs">Call venue</span>
        </a>
        <a href={`https://wa.me/?text=${waText}`} target="_blank" rel="noreferrer" className="tablo-card p-4 hover:shadow-tablo-lg flex flex-col items-center gap-1" data-testid="confirm-share-btn">
          <Share2 className="w-4 h-4 text-amber" strokeWidth={1.6}/>
          <span className="text-xs">Share</span>
        </a>
        <button className="tablo-card p-4 hover:shadow-tablo-lg flex flex-col items-center gap-1" data-testid="confirm-calendar-btn">
          <Calendar className="w-4 h-4 text-amber" strokeWidth={1.6}/>
          <span className="text-xs">Calendar</span>
        </button>
      </div>

      <Link to="/my-bookings" className="block tablo-btn-outline" data-testid="confirm-view-bookings-btn">See all my bookings</Link>
    </div>
  );
}
